import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.error.cause.js";
import ChooseImg from "@/components/chooseImg";
import { setUserInfo, changePassword } from "@/api/user";
import { mapGetters, mapMutations } from "vuex";
var path = process.env.VUE_APP_BASE_API;
export default {
  name: "Person",
  data: function data() {
    var _this = this;
    return {
      path: path,
      activeName: "second",
      showPassword: false,
      pwdModify: {},
      rules: {
        password: [{
          required: true,
          message: "请输入密码",
          trigger: "blur"
        }, {
          min: 6,
          message: "最少6个字符",
          trigger: "blur"
        }],
        newPassword: [{
          required: true,
          message: "请输入新密码",
          trigger: "blur"
        }, {
          min: 6,
          message: "最少6个字符",
          trigger: "blur"
        }],
        confirmPassword: [{
          required: true,
          message: "请输入确认密码",
          trigger: "blur"
        }, {
          min: 6,
          message: "最少6个字符",
          trigger: "blur"
        }, {
          validator: function validator(rule, value, callback) {
            if (value !== _this.pwdModify.newPassword) {
              callback(new Error("两次密码不一致"));
            } else {
              callback();
            }
          },
          trigger: "blur"
        }]
      }
    };
  },
  components: {
    ChooseImg: ChooseImg
  },
  computed: _objectSpread({}, mapGetters("user", ["userInfo", "token"])),
  methods: _objectSpread(_objectSpread({}, mapMutations("user", ["ResetUserInfo"])), {}, {
    savePassword: function savePassword() {
      var _this2 = this;
      this.$refs.modifyPwdForm.validate(function (valid) {
        if (valid) {
          changePassword({
            username: _this2.userInfo.userName,
            password: _this2.pwdModify.password,
            newPassword: _this2.pwdModify.newPassword
          }).then(function (res) {
            if (res.code == 0) {
              _this2.$message.success("修改密码成功！");
            }
            _this2.showPassword = false;
          });
        } else {
          return false;
        }
      });
    },
    clearPassword: function clearPassword() {
      this.pwdModify = {
        password: "",
        newPassword: "",
        confirmPassword: ""
      };
      this.$refs.modifyPwdForm.clearValidate();
    },
    openChooseImg: function openChooseImg() {
      this.$refs.chooseImg.open();
    },
    enterImg: function enterImg(url) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return setUserInfo({
                headerImg: url,
                ID: _this3.userInfo.ID
              });
            case 2:
              res = _context.sent;
              if (res.code == 0) {
                _this3.ResetUserInfo({
                  headerImg: url
                });
                _this3.$message({
                  type: "success",
                  message: "设置成功"
                });
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    }
  })
};